import { z } from "zod";
const twoDigitYearRegex = /^\d{2}$/;
export const TwoDigitYear = z
    .stringFormat("TwoDigitYear", (val) => twoDigitYearRegex.test(val))
    .brand();
export const fromMonthCodeYY = (monthCodeYY) => monthCodeYY.slice(1);
export const fromShortMonthYY = (monthCodeYY) => monthCodeYY.slice(3);
export const isTwoDigitNumber = (num) => num >= 0 && num <= 99 && num === (num | 0);
export const twoDigitNumberFromNumber = (num) => ((((num | 0) % 100) + 100) % 100);
export const asTwoDigitNumber = (year) => Number(year);
export const asTwoDigitNumberFromMonthCodeYY = (monthCodeYY) => asTwoDigitNumber(fromMonthCodeYY(monthCodeYY));
export const fromISODateString = (date) => date.substring(2, 4);
export const fromTwoDigitYearNumber = (num) => num.toString().padStart(2, "0");
export const fromNumber = (num) => fromTwoDigitYearNumber(twoDigitNumberFromNumber(num));
export const fromDayjs = (date) => date.format("YY");
export const fromDate = (date) => fromTwoDigitYearNumber((date.getFullYear() % 100));
export const fromUTCDate = (date) => fromTwoDigitYearNumber((date.getUTCFullYear() % 100));
export const add = (num, year) => fromNumber(asTwoDigitNumber(year) + num);
//# sourceMappingURL=two-digit-year.js.map